import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-personas',
  templateUrl: './personas.component.html',
  styleUrls: ['../../assets/css/custom.css']
})
export class PersonasComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }
  private fragment:string;

  ngOnInit() {
    this.route.params.subscribe(params=>{
      this.fragment = params['topic'];
       try {
        document.querySelector('#' + this.fragment).scrollIntoView();
        } catch (e) { }
    });
  }
}


// WEBPACK FOOTER //
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/src/app/personas/personas.component.ts